import { Trans } from 'react-i18next'
import styles from './statsNote.module.scss'
import ConfidenceTick from 'components/generic/ConfidenceTick'
import { useModalDispatch, useModalState } from 'hooks/use-modal'
import { CONFIDENCE_MODAL_ID } from 'components/profile/modals/ConfidenceModal'

const StatsNote = ({ isVerified = false }: { isVerified?: boolean }) => {
  const { isOpen } = useModalState(CONFIDENCE_MODAL_ID as never)
  const { modalActions, modalDispatch } = useModalDispatch(CONFIDENCE_MODAL_ID as never)

  const commonProps = {
    ns: 'strPlayerLevel',
    components: {
      button: (
        <button
          className={styles.btnModal}
          onClick={() => {
            modalDispatch(modalActions.openModal())
          }}
          aria-expanded={isOpen}
        />
      ),
      span: <ConfidenceTick score={100} className={styles.tick} />,
      br: <br />,
    },
  }

  const props: {
    ns: string
    i18nKey: string
    defaults: string
    components: {
      button: JSX.Element
      span: JSX.Element
      br: JSX.Element
    }
  } = isVerified
    ? {
        ...commonProps,
        i18nKey: 'verifiedText',
        defaults:
          'These statistics only include players with a <button>verified Singles WTN</button> (<span />).',
      }
    : {
        ...commonProps,
        i18nKey: 'unverifiedText',
        defaults:
          'These statistics only show for players with a <button>verified Singles WTN</button> (<span />). <br/>More match results are required to ensure accuracy.',
      }

  return (
    <small className={styles.note}>
      <Trans {...props} />
    </small>
  )
}

export default StatsNote
